module.exports = require('./CheckCasherRenewalApplicationView');
